module.exports = require('./CheckCasherRenewalApplicationView');
